<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <ListaNotificacoes />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import ListaNotificacoes from "../Components/Listagens/ListaNotificacoes.vue";
export default {
  name: "ListNotification",
  components: {
    ListaNotificacoes,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
